// extracted by mini-css-extract-plugin
module.exports = {"svg-icon":"icons_svg-icon_1o1Y6","ic_expand":"icons_ic_expand_1KpyE","ic_back":"icons_ic_back_2_T0y","ic_next":"icons_ic_next_1GlV-"};